import { useEffect, useState } from 'react'
import { watchForm } from '../../lib/formsData.js'
import FormAnalytics from './FormAnalytics.jsx'
import FormSubmissions from './FormSubmissions.jsx'

export default function FormPage({ formId, tab, onOpenSubmission, onNavigateTab }) {
  const [form, setForm] = useState(null)
  useEffect(() => watchForm(formId, setForm), [formId])
  const active = tab === 'submissions' ? 'submissions' : 'analytics'
  const tabBtn = (key, label) => (
    <button onClick={() => onNavigateTab(key)} className="btn" style={{ fontSize: 13, padding: '8px 14px', background: 'transparent', border: 'none', borderBottom: active === key ? '2px solid var(--color-gold)' : '2px solid transparent', color: active === key ? 'var(--color-white)' : 'var(--color-muted)', borderRadius: 0 }}>{label}</button>
  )
  return (
    <div>
      <div className="eyebrow" style={{ marginBottom: 8 }}><span className="tag-label" style={{ color: 'var(--color-gold)' }}>Form</span></div>
      <h1 className="font-display" style={{ fontSize: 34, margin: '0 0 14px', letterSpacing: '.01em', lineHeight: 1, textTransform: 'uppercase', color: 'var(--color-white)' }}>{form ? (form.name || form.slug) : 'Form'}</h1>
      <div style={{ display: 'flex', gap: 4, borderBottom: '1px solid var(--color-divider-dark)', marginBottom: 20 }}>
        {tabBtn('analytics', 'Analytics')}
        {tabBtn('submissions', 'Submissions')}
      </div>
      {active === 'analytics'
        ? <FormAnalytics formId={formId} />
        : <FormSubmissions formId={formId} onOpenSubmission={onOpenSubmission} />}
    </div>
  )
}
